import replaceAll from '@naturehouse/nh-essentials/lib/polyfills/replaceAll';
import Table from '../../../ui/web-components/table';

interface TemplateTableColumn {
    templateId: string;
    label: string;
    noWrap?: boolean;
}

class BookingsTable extends Table {
    readonly #templateColumns: TemplateTableColumn[];

    readonly #addTemplateColumns: TableColumn[] = [];

    constructor() {
        super();
        this.#templateColumns = JSON.parse(this.dataset.templateColumns || '[]');

        this.#templateColumns.forEach((templateColumn: TemplateTableColumn) => {
            const template = this.querySelector(
                `#${templateColumn.templateId}`
            ) as HTMLTemplateElement;

            if (!template) {
                return;
            }

            this.#addTemplateColumns.push({
                id: (booking: StandardObjectInterface): string => {
                    const statusClassMap: StandardObjectInterface = {
                        success: ['approved'],
                        error: ['cancelled'],
                        action: ['processing']
                    };

                    const bookingStatusClass = Object.keys(statusClassMap).find((key) =>
                        statusClassMap[key].includes(booking.bookingStatus)
                    );

                    let returnValue = template.innerHTML;
                    returnValue = replaceAll(
                        returnValue,
                        '_ifStatusIsDepositClass_',
                        booking.bookingStatus === 'approved' ? 'hidden' : ''
                    );
                    returnValue = replaceAll(
                        returnValue,
                        '_bookingStatusClass_',
                        String(bookingStatusClass)
                    );
                    returnValue = replaceAll(
                        returnValue,
                        '_bookingStatusText_',
                        booking.translatedStatus
                    );
                    returnValue = replaceAll(returnValue, '_bookingId_', String(booking.bookingId));

                    return returnValue;
                },
                title: templateColumn.label,
                noWrap: templateColumn.noWrap
            });
        });

        this.addColumns(this.#addTemplateColumns);
    }
}

if (!customElements.get('bookings-table')) {
    customElements.define('bookings-table', BookingsTable, { extends: 'table' });
}
